const prog_settings = {
  name: "prog_settings",
  label: "Programme Settings",
  editor: {
    preview: false,
  },
  description: "Setup for the Programme",
  folder: "content/settings",
  file: "prog_settings.md",

  fields: [
    {
      label: "Template",
      name: "template",
      widget: "hidden",
      default: "prog_settings",
      required: true,
    },
    {
      label: "Cadet Groups",
      name: "groups",
      widget: "list",
      required: true,
      fields: [
        {
          label: "Group",
          name: "group",
          widget: "string",
          required: true,
        },
      ],
    },
    {
      label: "Activities",
      name: "activities",
      widget: "list",
      required: true,
      field: {
        label: "Activity",
        name: "activity",
        widget: "string",
        required: true,
      },
    },
    {
      label: "Instructors",
      name: "instructors",
      widget: "list",
      required: true,
      summary: "{{instructor}}",
      fields: [
        {
          label: "Instructor",
          name: "instructor",
          widget: "string",
          required: true,
        },
      ],
    },
    {
      label: "Uniform Options",
      name: "uniforms",
      widget: "list",
      required: true,
      summary: "{{uniform}}",
      fields: [
        {
          label: "Uniform",
          name: "uniform",
          widget: "string",
          required: true,
        },
        {
          label: "What colour background?",
          name: "bgcol",
          widget: "color",
          required: true,
          allowInput: true,
        },
        {
          label: "What colour text?",
          name: "fgcol",
          widget: "color",
          required: true,
          allowInput: true,
        },
      ],
    },
  ],
};

export default prog_settings;
